import { SamplesBudgetApiClient } from '@fourthwall/services/dist/SamplesBudgetApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateSamplesCheckoutMutation = createMutationHook(
  SamplesBudgetApiClient.createCheckout,
  {
    mutationKey: ['createSamplesCheckout'],
  },
)
